import React from "react"

export default function Warning() {
  return (
    <symbol id="svg-warning" viewBox="0 0 24 22">
      <path
        fill="currentColor"
        d="M3.1 21.1c-.5 0-1-.1-1.6-.4-1.5-.8-2-2.8-1.2-4.3l9-14.9c.2-.4.6-.8 1-1 .7-.4 1.6-.5 2.4-.3.8.2 1.5.7 2 1.5l8.8 14.8c.3.5.4 1 .4 1.6 0 .8-.3 1.7-.9 2.2-.5.6-1.3.9-2.1.9H3.1zm8-18.5L2.3 17.4c-.3.5-.1 1.2.4 1.5.1.1.3.1.4.1h17.7c.3 0 .5-.1.7-.3s.3-.4.3-.7c0-.2 0-.3-.1-.5L13 2.6c-.3-.5-1-.6-1.5-.4-.2.1-.3.2-.4.4zm2 9V7.4c0-.6-.4-1-1-1s-1 .4-1 1v4.2c0 .6.4 1 1 1s1-.3 1-1zm-.3 5c.2-.2.3-.4.3-.7 0-.1 0-.3-.1-.4 0-.1-.1-.2-.2-.3 0 0-.1-.1-.2-.1s-.1-.1-.2-.1-.1 0-.2-.1c-.2 0-.4 0-.6.1-.1 0-.2.1-.3.2-.1.1-.2.2-.2.3s-.1.2-.1.4c0 .3.1.5.3.7s.4.3.7.3c.4 0 .6-.1.8-.3z"
      />
    </symbol>
  )
}
